import { apolloClient } from '~/apollo-client';
import {
  DocuSignEnvelopeCreateInput,
  Flex_GenerateDocuSignEnvelopeMutation,
  Flex_GenerateDocuSignEnvelopeMutationVariables,
} from '~/typings/graphql';
import { GENERATE_DOCU_SIGN_ENVELOPE } from './request-docu-sign-envelope.queries';

/**
 *  Requests a DocuSign Envelope be generated for the given
 *  contract version.  If the contract version is the Illinois
 *  disclosure form, Emperor Penguin will only actually create
 *  a new one if the specified user/utility account is in Illinois
 *  and doesn't already have a signable or completed envelope
 *  generated.  Note that the IL disclosure form is already
 *  requested on the backend in several other places (on
 *  scraper completion and VNM product lead creation currently),
 *  so this is just called to ensure that users who have expired
 *  envelopes or are missing one for some other reason don't get
 *  stuck.
 */
export const requestDocuSignEnvelope = async (
  params: RequestDocuSignEnvelopeParams,
): Promise<RequestDocuSignEnvelopeResponse> => {
  await apolloClient.mutate<
    Flex_GenerateDocuSignEnvelopeMutation,
    Flex_GenerateDocuSignEnvelopeMutationVariables
  >({
    mutation: GENERATE_DOCU_SIGN_ENVELOPE,
    variables: {
      input: {
        ...params,
      },
    },
  });
};

export type RequestDocuSignEnvelopeParams = DocuSignEnvelopeCreateInput;
export type RequestDocuSignEnvelopeResponse = void;
